<template>
  <div>
    <div class="mt-2">
      <recipient :model="schema.recipient" />
    </div>

    <div class="mt-2">
      <w-input :model="schema.title" />
    </div>

    <div class="mt-2">
      <w-wysiwyg :model="schema.content" :config="wyswigConfig" />
    </div>

    <div class="mt-2">
      <w-wysiwyg :model="schema.recivers" :config="reciversConfig" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Recipient from './components/Recipient';

// @vuese
// Formularz dokumentu ogólnego
// @group ActionData
export default {
  components: { ...components, Recipient },
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return {
      wyswigConfig: { allowedContent: true, height: 450 },
      recipientWyswigConfig: { allowedContent: true, height: 100 },
      reciversConfig: { allowedContent: true, height: 100 }
    };
  }
};
</script>
